import React, { useEffect, useState } from 'react';
import BackgroundImageCurve from "../responsive-carousel/BackgroundImageCurve";
import BackgroundImage from "../responsive-carousel/BackgroundImage";
import { makeStyles } from '@material-ui/core/styles';
import { Swiper, SwiperSlide } from "swiper/react";
import "./testimonial.scss"
// import Swiper core and required modules
import SwiperCore, {
  Pagination, 
  Navigation,
  Autoplay,
  Keyboard,
  EffectFade,
} from "swiper/core";
import TestimonialSlide from './TestimonialSlide';
import { isMobile } from 'react-device-detect';
import { moduleMargins } from '../../Constants';

// install Swiper modules
SwiperCore.use([Pagination, Navigation, Autoplay, EffectFade, Keyboard]);

function EirTestimonial(props) {

  const [carouselSpecs] = useState(props.carouselDetails.carosuselSpecs);
  const [slides] = useState(props.carouselDetails.slideContent)  
 
  useEffect(() => {
    // const cdtContent=slides.filter(content => content.countdownTimer!=undefined)
    
   //Swiper Navigators
   const nextNav = document.querySelector(".swiper-button-next");
   const prevNav = document.querySelector(".swiper-button-prev");
   const pagination = document.querySelectorAll(".swiper-pagination > span");

   //Array of all Swiper Navigators
   const allNavigators = [
     nextNav,
     prevNav,
     ...Array.from(pagination).map((dot) => dot),
   ];

   const setTabIndex = (element) => {
     if(element!= null){
      element.setAttribute("tabindex", 0);
      element.setAttribute("role", "button");
     }
   
   };
   const onArrowFocus = (element) => {
   
    element.addEventListener("keypress", (e) => {
      if (e.key == "Enter" || e.keyCode == 13) {
        element.click();
      }
    });
   };

   //Setting JS Swiper Navigators
   allNavigators.map((element) => setTabIndex(element));
   allNavigators.forEach((element) =>{
    if(element!= null){
      element.addEventListener("focus", onArrowFocus(element))
     } 
   }
   
   );

  }, [])

  //animation timeout is not working
  const animationTimeout = parseInt(carouselSpecs.AnimationTimeout!=undefined? carouselSpecs.AnimationTimeout:"1000");
 
  const carouselProps =  {
    animation: carouselSpecs.Animation!=undefined? carouselSpecs.Animation:"slide",
    animationTimeout: !isNaN(animationTimeout)? animationTimeout:1000,
    autoPlay: carouselSpecs.AutoPlay!=undefined? carouselSpecs.AutoPlay=="true":true,
    loopInterval: carouselSpecs.LoopInterval!=undefined? carouselSpecs.LoopInterval:5000,
    indicators: {
      enabled: true,
      pagination: {
          style : {
            width:"10px",
            height:"10px",
            margin:"0 12px !important",
            background: carouselSpecs.navigator.navigatorPaginationDotColor !== undefined
            ? carouselSpecs.navigator.navigatorPaginationDotColor
            : "#FFFFFF"
          },
          pseudoActive: {
            background: carouselSpecs.navigator.navigatorPaginationDotActiveColor !== undefined
            ? carouselSpecs.navigator.navigatorPaginationDotActiveColor
            : "#FFFFFF"
          }
      }
    }
  }

  const animationEffects = {
    fadeEffect:{
      crossFade: carouselProps.animation=="fade"?true:false
    },
    slide:{
      
    }
  }
  
 
  const carouselStyle = makeStyles({
    root:{
      "& .swiper-button-next::after": {display:"none"},
      "& .swiper-button-prev::after": {display:"none"},
      "& .swiper-pagination-bullet":carouselProps.indicators.pagination.style,
      "& .swiper-pagination-bullet:focus":{opacity:0.7},
      "& .swiper-pagination-bullet-active":carouselProps.indicators.pagination.pseudoActive,
      "& .swiper-pagination": {
        bottom: "35px !important",
      } 
    }

  })

  let [marginDesktop, marginMobile] = moduleMargins(carouselSpecs.MarginDT, carouselSpecs.MarginMobile);

  return (
    <div className={"testimonial-container "+((!isMobile) ? marginDesktop : marginMobile)} id={`testimonial-${carouselSpecs.carouselOccurence}`}>
      {/* Carousel Swiper Container */}
     { slides.length > 1 && 
      <Swiper      
            className={`testimonial-swiper-container ${carouselStyle().root}`}  
            pagination={{
              clickable:"true"
            }}
            keyboard={{enabled:true}}
            spaceBetween={0}
            navigation={true} // nav arrow
            loop={true} //cycle
            enabled={true} // navs visibility
            autoplay={carouselProps.autoPlay && {
              delay: carouselProps.loopInterval, //loop interval
              pauseOnMouseEnter: true,
              disableOnInteraction: false
            }}
            effect={carouselProps.animation}
            fadeEffect={animationEffects.fadeEffect}
            speed={carouselProps.animationTimeout} //animation timeout
          >    
          {
            slides.map((slideContent, i) => {
                return <SwiperSlide className={`testimonial-swiper-slides`} key={i}>
                      <TestimonialSlide isTimer={false} slidedata={slideContent} heightClass={""} isForeground={slideContent.foregroundImage!==undefined}/>
                    
                      {/* slide background image */}
                      <BackgroundImage image={slideContent.backgroundImage}/>
                    </SwiperSlide>
                }
              )
          }
      </Swiper>
      }

      {/* if single slide only */}
      {
        slides.length == 1 && <div  className={`testimonial-swiper-container ${carouselStyle().root}`} >
        {
          slides.map((slideContent, i) => {
              return (
                <SwiperSlide className={`swiper-container testimonial-swiper-slides`} key={i}>
                  <TestimonialSlide isTimer={false} slidedata={slideContent} heightClass={""} isForeground={slideContent.foregroundImage!==undefined}/>
                  
                  {/* slide background image */}
                  <BackgroundImage image={slideContent.backgroundImage}/>
                </SwiperSlide>
                )
              }
            )
        }
        </div>
      }
      {/* Carousel Curve */}
      {/* {carouselSpecs.curveRequiredIn!="none" && <BackgroundImageCurve curveCondition={carouselSpecs.curveRequiredIn } sources={carouselSpecs.curveImage}/>} */}
    </div >
  );
}
export default EirTestimonial;